import { useEffect } from "react";
import { isTyping } from "../shell/shortcuts";
import { runUndo } from "./undo";

/**
 * ⌘Z / Ctrl Z runs the undo the last save offered (ADR-282), once in the frame of the app. In a field it stays the
 * field's own: the text typed in a cell is undone by the browser.
 */
export function useUndoShortcut(): void {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (!(e.metaKey || e.ctrlKey) || e.shiftKey || e.altKey || e.key.toLowerCase() !== "z") return;
      if (isTyping(e.target)) return;
      if (runUndo()) e.preventDefault();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);
}
